<template>
   <!--天气模块-->
   <div id='weather' class='weather-part'>
      <div class='time'>{{time}}</div>
      <div class='date'>{{date}}</div>
      <div class='week'>
        {{weekDay}}
      </div>
      <div class='divide-line'></div>
      <div class='weather-font'>
         <span class='pic-cont'><img :src='weatherImg'/></span>{{weather}}
      </div>
      <div class='degree'>
       <span class='pic-cont'><img src='http://img.yimutian.com/crm/5da1a00cb827736e3b0b860f4606d1fe.png'></span>
      {{degreeMin}}<span class='degree-sym'>&#8451;</span> ~ {{degreeMax}}<span class='degree-sym'>&#8451;</span></div>
   </div>
</template>
<script>
import { http } from '@/http'

export default{
  props: {
    countyId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      time: '00:00',
      date: '2019/01/02',
      weekDay: '星期六',
      weather: '大暴雨到特大暴雨',
      degree: '28',
      weatherImages: [], // 存放天气图标
      weatherImg: '',
      degreeMax: 0,
      degreeMin: 0
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      http.get('/canmou/tianji/product/weather?county_id=' + this.countyId).then(res => {
        this.dataResponse = res.data
        const { date: dateStr, weather, min_temp: degreeMin, max_temp: degreeMax } = this.dataResponse.data
        this.date = `${dateStr.substring(0, 4)}/${dateStr.substring(4, 6)}/${dateStr.substring(6, 8)}`
        this.weekDay = this.getWeekday()
        this.weather = weather
        this.degreeMin = degreeMin
        this.degreeMax = degreeMax
        if (this.dataResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 获取当前日期是周几
    getWeekday () {
      let datetime = new Date()
      return ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][datetime.getDay()]
    },
    setTime () {
      let datetime = new Date()
      let hour = datetime.getHours()
      let minutes = datetime.getMinutes()
      hour = hour < 10 ? '0' + hour : hour
      minutes = minutes < 10 ? '0' + minutes : minutes
      this.time = hour + ':' + minutes
    }
  },
  mounted () {
    // 获取数据
    this.getData(() => {
      var that = this
      setInterval(() => {
        that.setTime()
      })
    })
  }
}

</script>
<style lang='less' scoped>
 .pic-cont{
   display:inline-block;
   height:44px;
   line-height:44px;
 }
 .pic-cont img{
   vertical-align:middle;
   height:80%;
   width:auto;
   margin-right:5px;
 }
.degree-sym{
  font-size:25px;
}
.divide-line{
  width:2px;
  height:44px;
  background:#0fffff;
}
.date,.week,.weather-font{
  font-size:23px;
}
.time,.degree{
  font-size:38px;
}
 .weather-part{
   height:100%;
   color:#0fffff;
   display:flex;
   align-items:center;
   justify-content:space-around;
 }
 .weather-part>div{
    float:left;
 }
  .provide_container{
    width: 100%;
    height:100%;
    background:none;
  }
</style>
